import { InjectionToken } from '@angular/core';

/**
 * Фабрика создаёт новый Worker при каждом вызове (см. initWorker с kill).
 * Регистрируется в приложении skypro-public; в Storybook — в story.
 */
export const PYTHON_WORKER_FACTORY = new InjectionToken<() => Worker>('PYTHON_WORKER_FACTORY');
